import { Alert } from "@exopengithub/exokit";
import type { ComponentProps, ReactNode } from "react";

type Props = Omit<ComponentProps<typeof Alert>, "children"> & {
	summary: ReactNode;
	children: ReactNode;
};

/** Collapsed by default (native `<details>`) so a long list doesn't bury the page below it. */
export const CollapsibleAlert = ({ summary, children, ...rest }: Props) => (
	<Alert {...rest}>
		<details>
			<summary>{summary}</summary>
			{children}
		</details>
	</Alert>
);
